/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Err_Source_LotInputs */

const vi_scl_new_err_source_lot = /** @type {(inputs: Scl_New_Err_Source_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô phân loại nguồn`)
};

/**

* @param {Scl_New_Err_Source_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_err_source_lot = /** @type {((inputs?: Scl_New_Err_Source_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Err_Source_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_err_source_lot(inputs)
});